import { RQService }                 from '../../RQuery/RQuery';
import { Component }                 from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { AlertController }           from 'ionic-angular';
import { dmHotel }                   from '../sign-in/xv-hotel';
import { ChangePINViewModel }        from './xv-change-pin-popover';
import { MLText, mlBroker }          from '../../services/MLText';
import { AppDataBroker }             from '../../services/AppData';

@Component({
     selector:    'page-change-pin-popover'
    ,templateUrl: 'change-pin-popover.html'
})
export class ChangePINPopoverPage {
    ChangePIN: ChangePINViewModel;
    ShowAlert: (pTitle: string, pMessage: string) => void;
    Dismiss:   (pAction: () => void)              => void;

    app:       mlBroker;

    constructor(
         public viewCtrl:      ViewController
        ,public navParams:     NavParams
        ,public alertCtrl:     AlertController
        ,public mlText:        MLText
        ,public appDataBroker: AppDataBroker
    ) {
        let hotel       = appDataBroker.GetAppData() as dmHotel;

        this.app        = this.mlText.GetBroker('BookingEngineAppTexts');

        this.Dismiss    = (pAction: () => void) => {
            this.viewCtrl.dismiss(pAction);
        };

        this.ShowAlert  = (pTitle: string, pMessage: string) => {
            let alert   = this.alertCtrl.create({
                 title:   pTitle
                ,message: pMessage
                ,buttons: [
                    {
                         text:    this.app.Text('OK')
                        ,handler: () => { return true; }
                    }
                ]
            });

            alert.present();
        };

        this.ChangePIN  = new ChangePINViewModel(
             this.mlText
            ,hotel
            ,this.Dismiss
            ,this.ShowAlert
        );

        this.ChangePIN.initialise(
            this.navParams.data.staff as RQService.Tasks.GetStaffRow
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/change-pin-popover.ts